import defaultValue from "./shortListSlice";

export default defaultValue;

export * from "./shortListSlice";
export * from "./shortListSlice.types";
